export const CAMERA_PRESETS = {
    ["TopDown45" /* CameraPreset.TopDown45 */]: {
        cameraOption: {
            fov: 45,
            aspect: 2,
            near: 0.1,
            far: 100,
        },
        cameraXRotation: -Math.PI / 4
    },
    ["TopDown30" /* CameraPreset.TopDown30 */]: {
        cameraOption: {
            fov: 45,
            aspect: 2,
            near: 0.1,
            far: 100,
        },
        cameraXRotation: -Math.PI / 6
    },
    ["TopDown20" /* CameraPreset.TopDown20 */]: {
        cameraOption: {
            fov: 45,
            aspect: 2,
            near: 0.1,
            far: 100,
        },
        cameraXRotation: -Math.PI / 9
    }
};
export const LIGHTING_PRESETS = {
    ["Standard" /* LightingPreset.Standard */]: {
        color: 0xFFFFFF,
        intensity: 2,
        hemisphereLightIntensity: 0.75,
    }
};
//# sourceMappingURL=ThreeJSPresets.js.map